import { PrototypeModel, PrototypeField } from './prototype-model';
import { Content } from '../tree/content';
import { Site } from '../tree/site';
import { Genus } from '../tree/genus';
import { get } from 'lodash';
import { ContentField } from './content-field';

export class ContentModel {
    tags: {key: string, value: ContentField[]}[] = [];

    constructor(
        private readonly prototypeModel: PrototypeModel,
        content: Content | Site | Genus,
        custome: any
    ) {
        if (!!prototypeModel && !!content) {
            const map = new Map<string, ContentField[]>();
            // _id  of batch content is not set, so we allow mandatory fields to be false for batch content
            const allowMandatory = content._id?.length ? true : false;
            this.prototypeModel.fields.forEach(field => {
                if (field.value?.tag && field.value.type) {
                    let entry = map.get(field.value.tag);
                    if (!entry) {
                        map.set(field.value.tag, entry = []);
                        if (custome) {
                            custome[field.value.tag] = custome[field.value.tag] || { expanded: true };
                        }
                    }
                    const contentField = {
                        meta: this.getMeta(field, allowMandatory),
                        model: this.getModel(field, content),
                        input: field.value.type.input.name
                    };
                    entry.push(contentField);
                }
            });

            this.tags = ([...map.entries()].map(([key, value]) => ({key, value})));
        }
    }

    getMeta(field: PrototypeField, allowMandatory: boolean) {
        const { type, typeId, readonly, ...rest } = field.value;
        return {typeId, ...type.data, ...rest, ...{id: field.key, mandatory: allowMandatory && field.value.mandatory} };
    }

    getModel(field: PrototypeField, content: Content | Site | Genus) {
        if (!field.key) {
            return undefined;
        }
        const result = get(content.data, field.key);
        return result;
    }
}


